import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container, Button, Row, Col, UncontrolledTooltip, InputGroup, Input, FormGroup, Label, InputGroupText } from 'reactstrap';
import * as actions from '../actions/Users';
import { getUser } from '../actions/User';
import Breadcrumb from '../components/AdminBreadcrumb';

import UserList from '../components/users/UserList'

import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AddIcon from '@mui/icons-material/AddOutlined';
import DeleteConfirmation from '../components/MultiDeleteConfirmation';
import { getOptionsFromListofMaps } from '../utils';
import NewUserModal from '../components/person/PasswordChangeModal';

class Users extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            displayConfirmation: false,
            selectedUsers: [],
            disableDelete: true
        }
    }

    componentDidMount() {
        this.props.actions.getRoles();

        //change to some reset action...
        this.props.actions.getUsersByRole('');
    }

    componentWillUnmount() {
        this.props.actions.clearUsersState();
    }

    handleSelect = (id) => {
        this.props.actions.getUser(id);
        this.props.history.push(`users/user/${id}`, { id })
    };

    handleDelete = () => {
        this.props.actions.deleteUsers(this.role, this.state.selectedUsers.map(x => x.userId));
        this.setState({ displayConfirmation: !this.state.displayConfirmation, disableDelete: true });
    }

    handleSelectionChanged = (selectedUsers) => this.setState({ selectedUsers });

    handleRoleChange = (e) => {
        this.role = e.target.value;
        this.props.actions.getUsersByRole(this.role, this.includeInactive);
    }

    handleInactiveChange = (e) => {
        this.includeInactive = e.target.checked;
        this.props.actions.getUsersByRole(this.role, this.includeInactive);
    }

    handleDeleteClick = (e) => this.setState({ displayConfirmation: this.state.selectedUsers.length > 0, disableDelete: true });

    handleDeleteConfirmationToggle = () => {
        this.setState({ displayConfirmation: !this.state.displayConfirmation, disableDelete: false });
    }

    handleToggleNewUserModal = () => this.props.actions.toggleNewUserModal();

    handleSaveNewUser = (newUser, firstName, lastName) => {
        this.props.actions.saveNewUser(this.role, newUser, firstName, lastName)
    };

    setDisableTrash = () => {
        this.setState({ disableDelete: true });
    }

    setEnableTrash = () => {
        this.setState({ disableDelete: false });
    }

    render() {
        if (this.props.newUserId) {
            this.props.actions.getUser(this.props.newUserId);
            this.props.history.push(`users/user/${this.props.newUserId}`);
            this.props.actions.clearUsersState();
        }

        return (

            <Container>
                <div style={{ paddingBottom: '10px' }}>
                    <Breadcrumb history={this.props.history} />
                </div>
                <Row className='pb-1'>
                    <Col className='align-self-center'>
                        <InputGroup size="sm">
                            <InputGroupText>Role:</InputGroupText>
                            <Input type='select' disabled={!this.props.isAdmin} id='selectRoles' onChange={this.handleRoleChange} placeholder='Select a Role' value={this.role}>
                                {getOptionsFromListofMaps(this.props.roles, 'roleId', 'name')}
                            </Input>
                        </InputGroup>
                    </Col>
                    <Col className='d-flex align-items-center'>
                        <FormGroup check>
                            <Label check>
                                <Input type="checkbox" disabled={!this.props.isAdmin} id="inactive" onChange={this.handleInactiveChange} />{' '}
                                Show Inactive Users
                                 </Label>
                        </FormGroup>
                    </Col>
                    <Col className='d-flex flex-row-reverse'>
                        <Button id='deleteUserButton' disabled={this.state.disableDelete || !this.props.isAdmin} onClick={this.handleDeleteClick}><DeleteIcon /></Button>
                        <Button id='addUserButton' disabled={!this.props.isAdmin} onClick={this.handleToggleNewUserModal} className='me-1'><AddIcon /></Button>
                        <UncontrolledTooltip delay={{ show: 0, hide: 0 }} target='addUserButton'>Add a new user.</UncontrolledTooltip>
                        <UncontrolledTooltip delay={{ show: 0, hide: 0 }} target='deleteUserButton'>Delete a user.</UncontrolledTooltip>
                        <NewUserModal
                            title='New User'
                            showEmail={true}
                            onSave={this.handleSaveNewUser }
                            showModal={this.props.showNewUserModal}
                            onToggle={this.handleToggleNewUserModal}
                            validationMessages={this.props.passwordValidationMessages}
                        />
                    </Col>
                </Row>
                <UserList
                    setDisableTrash={this.setDisableTrash}
                    setEnableTrash={this.setEnableTrash}
                    data={this.props.users.toJS()}
                    onSelect={this.handleSelect}
                    onSelectionChanged={this.handleSelectionChanged}
                    roles={this.props.roles}
                />
                <DeleteConfirmation
                    title={`Delete Users`}
                    onDelete={this.handleDelete}
                    onToggle={this.handleDeleteConfirmationToggle}
                    toDelete={this.state.selectedUsers.map(x => x.displayName + " - " + x.userName)}
                    isOpen={this.state.displayConfirmation}
                />
            </Container>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        newUserId: state.Users.get('newUserId'),
        roles: state.Users.get('roles'),
        users: state.Users.get('userList'),
        showNewUserModal: state.Users.get('showNewUserModal'),
        passwordValidationMessages: state.Users.get('passwordValidationMessages').toJS(),
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions, getUser }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);